// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"b4f95b00","108":"e07a3d9e","202":"d25098bb","265":"ce29e31f","294":"85f642da","821":"881e976e","913":"e8adc562"}[chunkId] + ".chunk.js";
};